import request from '@/providers/http-service'

// 查询用户权限
export function getPermission(params) {
  return request({
    url: `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-service/iam/user/permission`,
    method: 'get',
    data:params
  })
}

export function getUserInfo(params) {
  return request({
    url: `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-service/iam/user/info`,
    method: 'get',
     data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/sso.js